// extracted by mini-css-extract-plugin
module.exports = {"nav-bar":"Layout_nav-bar__2jTzW","content":"Layout_content__1t8Hf"};